import React from "react";
import ItemRow from "@/components/ItemRow";
import StreakStrip from "@/components/StreakStrip";
import { EmptyState } from "@/components/EmptyState";
import { relativeDateLabel } from "@/lib/dates";

// Habits tab body — search-result mode + normal today-list mode.
export default function HabitList({
    q, query, searchLoading, results,
    today, todaysHabits,
    onSearchToggle, onSearchDelete,
    onToggleHabit, onDeleteHabit, onEditHabit, onOpenEditHabit,
    onOpenScheduleEditor, onAskCoverHabit,
}) {
    if (q) {
        if (results.length === 0) {
            return <EmptyState text={searchLoading ? "Searching…" : `No habits match "${query}".`} />;
        }
        return results.map((r) => (
            <ItemRow
                key={r.id}
                title={r.title}
                completed={r.completed}
                time={r.time}
                streak={r.streak || 0}
                dateChip={r.date ? `starts ${relativeDateLabel(r.date, today)}` : null}
                onToggle={() => onSearchToggle(r)}
                onDelete={() => onSearchDelete(r)}
                onOpenEdit={onOpenEditHabit ? () => onOpenEditHabit(r) : undefined}
                testId={`habit-row-${r.id}`}
            />
        ));
    }
    return (
        <>
            {todaysHabits.length === 0 && <EmptyState text="No habits scheduled today. Tap + to plant one." />}
            {todaysHabits.map((h) => {
                const done = (h.completed_dates || []).includes(today);
                const coveredToday = (h.covered_dates || []).includes(today);
                // Eligible if streak ≥ 3 AND not yet done today AND host wants the menu.
                const eligibleForCover = !done && (h.streak || 0) >= 3 && !!onAskCoverHabit;
                return (
                    <ItemRow
                        key={h.id}
                        title={h.title}
                        completed={done}
                        coveredToday={coveredToday}
                        time={h.time}
                        streak={h.streak || 0}
                        onToggle={() => onToggleHabit(h)}
                        onDelete={() => onDeleteHabit(h)}
                        onEditTitle={onEditHabit ? (next) => onEditHabit(h, { title: next }) : undefined}
                        onEditSchedule={onEditHabit ? () => onOpenScheduleEditor(h) : undefined}
                        onOpenEdit={onOpenEditHabit ? () => onOpenEditHabit(h) : undefined}
                        onAskCover={eligibleForCover ? () => onAskCoverHabit(h) : undefined}
                        historyStrip={<StreakStrip habit={h} todayKey={today} />}
                        testId={`habit-row-${h.id}`}
                    />
                );
            })}
        </>
    );
}
